// ltracker/static/js/quotes.js

const quotes = [
  "Follow up until 'no' becomes 'not yet'.",
  "Your next closing is often one call away.",
  "Speed wins offers; clarity wins clients.",
  "Great agents don’t chase deals—they guide decisions.",
  "Every showing is a story; listen for the ending.",
  "Price is a fact, value is a conversation.",
  "Details sell homes: light, layout, and location.",
  "Negotiation is empathy with numbers.",
  "Trust is the best down payment.",
  "Consistency beats charisma in real estate.",
  "Local knowledge turns browsers into buyers.",
  "Ask better questions, write better contracts.",
  "Inspection day is where calm earns loyalty.",
  "Lead with service; commission follows.",
  "Every objection is a request for reassurance.",
  "Timing matters—so does readiness.",
  "New listing? Notify fast, follow up faster.",
  "A clean timeline beats a messy memory.",
  "Pipeline health is built on daily touches.",
  "Options reduce fear; clarity creates action.",
  "Your reputation is your referral engine.",
  "One great conversation can fund a whole quarter.",
  "Showings don’t close deals—next steps do.",
  "Set expectations early, exceed them often.",
  "Buyers want certainty; sellers want confidence.",
  "Location gets attention; preparation gets offers.",
  "Marketing attracts; follow-up converts.",
  "Your CRM is your second brain.",
  "Protect the client like it’s your own money.",
  "Small updates prevent big surprises.",
  "Comfort sells—make every tour feel easy.",
  "Photos get clicks; accuracy gets appointments.",
  "Price it right or chase it down.",
  "Negotiation starts with understanding motivations.",
  "Empathy is the sharpest closing tool.",
  "Prepare comps like you’re testifying.",
  "Contracts reward patience and precision.",
  "Great agents manage emotions and timelines.",
  "Follow-up is the quiet superpower.",
  "Your calendar is your commission plan.",
  "A good listing plan is a promise kept.",
  "Guidance turns stress into momentum.",
  "Be early to the market, not late to the offer.",
  "The best deals are built on clear communication.",
  "Every lead deserves a system, not a mood.",
  "Listen twice as much as you speak.",
  "Pre-approval turns dreams into decisions.",
  "Remember: you sell outcomes, not square feet.",
  "Negotiation is calm, not combat.",
  "Show, don’t tell—let the home speak.",
  "Small staging changes create big perception shifts.",
  "Confidence comes from preparation.",
  "Your next referral is today’s service.",
  "Deadlines are real; reminders are kindness.",
  "Keep notes like your future self depends on them.",
  "Momentum is created, not found.",
  "Make the next step obvious.",
  "Don’t guess—verify: taxes, HOA, and disclosures.",
  "Clients remember how you made them feel informed.",
  "A strong offer is simple, clean, and credible.",
  "Price reductions are strategy, not failure.",
  "Respect the other side; win the terms.",
  "Be the calmest person in the transaction.",
  "Home is emotional; paperwork is logical—handle both.",
  "Turn ‘maybe’ into ‘when’ with a plan.",
  "Follow-up is leadership in disguise.",
  "Your database is a garden—water it daily.",
  "Market updates build trust before decisions.",
  "Under-promise, over-deliver, always document.",
  "Clear comps beat loud opinions.",
  "Great agents create clarity under pressure.",
  "Response time is a competitive advantage.",
  "Your brand is built in the small moments.",
  "Every no-show is a chance to improve the process.",
  "One extra check saves one big headache.",
  "Be honest about trade-offs; clients respect it.",
  "Handle objections with facts and empathy.",
  "Make listing prep a checklist, not a scramble.",
  "Fast feedback keeps buyers engaged.",
  "Track touchpoints like you track dollars.",
  "Be proactive on appraisal day.",
  "Every negotiation needs a BATNA and a backup plan.",
  "Closing is a milestone; relationship is the journey.",
  "Education builds confidence; confidence makes offers.",
  "Follow-up is not pushy when it’s helpful.",
  "Great agents don’t disappear after the contract.",
  "Your notes today prevent confusion tomorrow.",
  "Protect time blocks like you protect client trust.",
  "Good photos are marketing; good data is integrity.",
  "Clients don’t want hype—they want guidance.",
  "Lead with transparency; it shortens the cycle.",
  "Every lead has a timeline—find it.",
  "Make the process feel predictable.",
  "Referrals are earned in the hard parts.",
  "A calm update is better than a late surprise.",
  "Winning offers are built on certainty and speed.",
  "Service is the strategy.",
  "Treat every lead like a future referral.",
  "Real estate is local—relationships are universal.",
];

const quoteBox = document.getElementById("quote");

/**
 * Pick a random footer quote and avoid repeating any of the last 9 shown.
 * We store recent quote indexes in localStorage and re-roll a few times to
 * find a fresh one, falling back to any random quote if needed.
 */

function readRecentIndexes(key, maxLen) {
  try {
    const raw = localStorage.getItem(key);
    const parsed = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(parsed)) {
      return [];
    }
    return parsed
      .map((x) => Number(x))
      .filter((x) => Number.isInteger(x))
      .slice(0, maxLen);
  } catch {
    return [];
  }
}

function writeRecentIndexes(key, indexes, maxLen) {
  try {
    const trimmed = indexes.slice(0, maxLen);
    localStorage.setItem(key, JSON.stringify(trimmed));
  } catch {
    // Ignore storage failures (private mode, full storage, etc.)
  }
}

function pickQuoteIndexAvoidingRecent(quotesLen, recent, maxAttempts = 25) {
  if (quotesLen <= 0) {
    return -1;
  }

  // If we have too few quotes, don't try too hard to avoid repeats.
  if (quotesLen <= recent.length + 1) {
    return Math.floor(Math.random() * quotesLen);
  }

  let idx = Math.floor(Math.random() * quotesLen);
  let attempts = 0;

  while (recent.includes(idx) && attempts < maxAttempts) {
    idx = Math.floor(Math.random() * quotesLen);
    attempts += 1;
  }

  return idx;
}

if (quoteBox && quotes.length) {
  const RECENT_KEY = "ltracker.quote_recent_indexes";
  const MAX_RECENT = 9;

  const recent = readRecentIndexes(RECENT_KEY, MAX_RECENT);
  const idx = pickQuoteIndexAvoidingRecent(quotes.length, recent);

  if (idx >= 0) {
    quoteBox.textContent = quotes[idx];
    writeRecentIndexes(RECENT_KEY, [idx, ...recent], MAX_RECENT);
  }
}
